/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/TextboxShape',['underscore', '../../nls/StringResources', './Shape', 'fabric'], function (_, StringResources, Shape) {
	'use strict';

	var TextboxShape = Shape.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			TextboxShape.inherited('init', this, arguments);
			options.canvas.isDrawingMode = false;

			this.originalX = options.xCoord;
			this.originalY = options.yCoord;

			this.shape = new window.fabric.Textbox(StringResources.get('textbox_placeholder'), _.extend({}, this.defaultAttributes, {
				left: options.xCoord,
				top: options.yCoord,
				originX: 'left',
				originY: 'top',
				width: 200,
				height: 200,
				textAlign: 'left',
				fontSize: 16,
				breakWords: true,
				stroke: options.borderColor,
				fill: options.borderColor,
				figure: 'textbox',
				hasControls: false,
				fontFamily: window.getComputedStyle(document.body).fontFamily
			}));
			options.canvas.add(this.shape);
			options.canvas.setActiveObject(this.shape);
			this.shape.selectAll();
			this.shape.enterEditing();
		}
	});

	TextboxShape.drawControlsVisibility = function (canvas, shape) {
		shape.setControlsVisibility({
			mtr: true,
			mb: false,
			mt: false,
			ml: true,
			mr: true,
			tl: true,
			br: true,
			tr: true,
			bl: true
		});
	};

	TextboxShape.scale = function (shape) {
		if (!shape.strokeWidthUnscaled && shape.strokeWidth) {
			shape.strokeWidthUnscaled = shape.strokeWidth;
		}
		if (shape.strokeWidthUnscaled) {
			// This is an aproximation of a scaled 1px stroke that looks good enough
			shape.strokeWidth = shape.strokeWidthUnscaled / ((shape.scaleX + shape.scaleY) / 2);
		}
	};

	TextboxShape.canUpdate = function () {
		return true;
	};

	TextboxShape.canSkew = function () {
		return true;
	};

	TextboxShape.handleEnterKeyEvent = function (shape) {
		shape.selectAll();
		shape.enterEditing();
	};

	return TextboxShape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

